import { cn, Skeleton as HeritageSkeleton } from '@herit-fe/heritage-ui';

/**
 * 스켈레톤 — heritage `Skeleton` 을 heviton 표면 체계에 맞춰 감싼 모듈. 채움색은 **놓이는 표면**에 따라 갈린다.
 *
 * heritage 기본은 `bg-muted` 한 벌뿐인데, 우리는 표면이 두 층이다(카드=흰색/`gray-800` · 콘텐츠 배경=`gray-100`/
 * `gray-900`). `--muted` 는 **카드 위** 기준으로 맞춰져 있어(light `gray-100`) 콘텐츠 배경 위에 그대로 쓰면 배경과
 * 같은 색이라 스켈레톤이 사라진다 → 그 자리엔 `ContentSkeleton`.
 */

/** 카드(`Card`·`ElevatedCard`) 위 스켈레톤 — heritage 기본(`bg-muted`). 표면과 Δ L ≈ 0.03(light)·0.10(dark). */
export { HeritageSkeleton as Skeleton };

/**
 * 콘텐츠 배경(`bg-heviton-bg-tinted`) 위 스켈레톤 — 카드 밖, 페이지 면에 직접 놓일 때. 배경보다 한 스텝 진하게
 * (light `gray-200`) / 밝게(dark `gray-800`) 해 기본 스켈레톤과 **동일한 단차**를 유지한다(Δ L 0.039 · 0.068).
 * 토큰을 새로 파지 않은 건 이 한 컴포넌트에서만 쓰는 값이라 `--heviton-*` 증식을 피하기 위함(파일 상단 TODO).
 */
export function ContentSkeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <HeritageSkeleton className={cn('bg-gray-200 dark:bg-gray-800', className)} {...props} />;
}
